import React from 'react'
import Styles from './index.module.scss'
import BeatLoader from 'react-spinners/BeatLoader'

function BeatLoaderC({ color }: any) {
  return (
    <>
      <BeatLoader className={Styles.loader} color={color} />
    </>
  )
}
export default BeatLoaderC
